import { Injectable, inject } from '@angular/core';

import { Oauth2Service, User, UserService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

import { tunnelRoutes } from '@tunnel/routes';

import { Observable, of } from 'rxjs';

import { StepMock } from '../../../interfaces/mock.interface';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class SirenStep extends Step {
    public static readonly key: string = 'siren';
    public shortLabel: string = 'SIREN';
    public label: string = 'Identification de votre société';
    public next: Step;
    public routerLink: string = `/tunnel/${tunnelRoutes.siren}`;
    public hasReminder = true;
    public icon: string = 'tri-identity';
    public stepMocks: StepMock[] = [
        {
            url: '/controleSiren/',
            mocks: [
                {
                    key: 'siren_sans_representant',
                    label: 'Siren sans représentant légal',
                    data: {
                        adresseDeclaree: {
                            cp: '35740',
                            ville: 'PACE',
                            voie: 'Jardins de la Teillais',
                        },
                        codeApeNaf: '741J',
                        codeEffectif: '120000',
                        dateCreation: '2008-01-01',
                        formeJuridique: 'ADMINISTRATION',
                        noSiren: '111111111',
                        raisonSociale: 'BOEHRINGER INGELHEIM FRANCE ehuzehuzae rhaurhe',
                    },
                },
                {
                    key: 'siren',
                    label: 'Siren avec représentant légal',
                    data: {
                        adresseDeclaree: {
                            cp: '89520',
                            num: '201',
                            ville: 'CLAMART',
                            voie: 'AVENUE JEAN JAURES',
                        },
                        codeApeNaf: '1071C',
                        codeEffectif: '8',
                        codeNIC: '00010',
                        dateCreation: '2005-09-01',
                        formeJuridique: 'ENTREPRISE_INDIVIDUELLE',
                        noSiren: '484036322',
                        raisonSociale: 'PATRICK DUMONT',
                        representantLegal: {
                            civilite: 'MLLE',
                            dateNaissance: '1974-02-04',
                            nom: 'DUMONT',
                            prenom: 'Patrick',
                        },
                        situationEntreprise: 'BONNE',
                    },
                },
            ],
        },
    ];

    protected cartService = inject(MainCartService);
    protected oauth2Service = inject(Oauth2Service);
    protected userService = inject(UserService);

    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public validate(): boolean {
        return true;
    }

    public canAccess(): Observable<boolean> {
        return of(this.canDisplay());
    }

    public canDisplay(): boolean {
        return this.cartService.cartModel.isPro && !this.oauth2Service.isConnected;
    }

    public forceReminder(): boolean {
        return this.oauth2Service.isConnected && !!this.userService.user?.siren;
    }

    public getReminderData(): string {
        const user: User = this.userService.user;
        return user?.siren || '';
    }
}
